export default __webpack_public_path__ + "static/media/step_009.126dbc55.png";